import {Toolbar} from '@material-ui/core';
import * as React from 'react';
import SaveButton from './SaveButton';
import DeleteButton from './DeleteButton';

export interface ToolbarProps {
    handleSubmit: Function;
    handleSubmitWithRedirect: Function;
    handleDelete: (id?: number | string) => void;
    loading?: boolean;
    record: Record<string, any>;
    resource?: string;
    saveButtonLabel?: string;
    saveButtonIcon?: React.FunctionComponent<object>;
    submitOnEnter?: boolean;
    formName: string;
    dispatch: Function;
}

const SimpleFormToolbar: React.FunctionComponent<ToolbarProps> = ({
    handleSubmitWithRedirect,
    handleDelete,
    loading,
    record,
    saveButtonLabel,
    saveButtonIcon,
    submitOnEnter,
}: ToolbarProps) => (
    <Toolbar className='edit-form-toolbar'>
        <div>
            <div className='save-div'>
                <SaveButton
                    handleSubmitWithRedirect={handleSubmitWithRedirect}
                    loading={loading}
                    saveButtonLabel={saveButtonLabel}
                    saveButtonIcon={saveButtonIcon}
                    submitOnEnter={submitOnEnter}
                />
            </div>
            <div className='right-div'>
                <div className='toolbar-list'/>
                <div className='delete-div'>
                    <DeleteButton
                        handleDelete={handleDelete}
                        record={record}
                    />
                </div>
            </div>
        </div>
    </Toolbar>
);

export default SimpleFormToolbar;
